import Repository from '../axios'
const resource = "/admin/sage";

export default {
  //AUTH
  confirmPermission(code){
    return Repository.get(`${resource}/auth-callback?code=${code}`)
  },

  // CUSTOMER
  getAccountStatusTypes() {
    return Repository.get(`${resource}/account_status_types`)
  },
  getExchangeRateTypes() {
    return Repository.get(`${resource}/exchange_rate_types`)
  },
  getCountryCodes() {
    return Repository.get(`${resource}/country_codes`)
  },
  getCurrencies() {
    return Repository.get(`${resource}/currencies`)
  },
  createCustomer(customer_id, payload) {
    return Repository.post(`${resource}/customers/${customer_id}`, payload)
  },
  linkSageCustomer(customer_id, payload) {
    return Repository.put(`${resource}/customer_existing/${customer_id}`, payload)
  },
  unLinkSageCustomer(customer_id, payload) {
    return Repository.put(`${resource}/customer_unlink/${customer_id}`, payload)
  },
  getSageCustomers(filter_query = ''){
    return Repository.get(`${resource}/customers?${filter_query}`)
  },
  getSageCustomerDetails(id) {
    return Repository.get(`${resource}/customers/${id}`)
  },
  updateSageCustomerDetails(id, payload) {
    return Repository.put(`${resource}/customers/${id}`, payload)
  },
  updateSageCustomerContactDetails(customer_id, contact_id, payload) {
    return Repository.put(`${resource}/customers/${customer_id}/customer-contacts/${contact_id}`, payload)
  },
  getCustomerContact(sage_customer_id, sage_contact_id) {
    return Repository.get(`${resource}/customers/${sage_customer_id}/customer-contacts/${sage_contact_id}`)
  },
  updateSageSupplierDetails(id, payload) {
    return Repository.put(`${resource}/suppliers/${id}`, payload)
  },

  // SUPPLIER
  createSupplier(supplier_id, payload) {
    return Repository.post(`${resource}/suppliers/${supplier_id}`, payload)
  },
  getSageSuppliers(filter_query = ''){
    return Repository.get(`${resource}/suppliers?${filter_query}`)
  },
  getSageSupplierDetails(id) {
    return Repository.get(`${resource}/suppliers/${id}`)
  },
  linkSageSupplier(supplier_id, payload) {
    return Repository.put(`${resource}/supplier_existing/${supplier_id}`, payload)
  },
  unLinkSageSupplier(supplier_id, payload) {
    return Repository.put(`${resource}/supplier_unlink/${supplier_id}`, payload)
  },

  //SALES ORDER
  createSalesOrder(payload) {
    return Repository.post(`${resource}/sop_orders`, payload)
  },
  createProductOrder(payload) {
    return Repository.post(`${resource}/pop_orders`, payload)
  },

  //RM ORDERS
  createRmOrder(payload) {
    return Repository.post(`${resource}/pop_orders`, payload)
  },

  //SO INVOICE
  createSalesOrderInvoice(payload) {
    return Repository.post('/admin/sage/sales-invoices', payload)
  },

  //CUSTOMER CONTACTS
  createCustomerContact(customer_id, payload) {
    return Repository.post(`/admin/sage/customers/${customer_id}/customer-contacts`, payload)
  },
  getSageCustomerContact (sage_customer_id, sage_contact_id) {
    return Repository.get(`/admin/sage/customers/${sage_customer_id}/customer-contacts/${sage_contact_id}`)
  },

  //SUPPLIER CONTACT
  createSupplierContact(supplier_id, payload) {
    return Repository.post(`/admin/sage/suppliers/${supplier_id}/contacts`, payload)
  },
  updateSageSupplierContactDetails(supplier_id, contact_id, payload) {
    return Repository.put(`${resource}/suppliers/${supplier_id}/contacts/${contact_id}`, payload)
  },
  getSupplierContact(sage_supplier_id, sage_contact_id) {
    return Repository.get(`${resource}/suppliers/${sage_supplier_id}/contacts/${sage_contact_id}`)
  },

  //SAGE AUTH
  getSageStatus(){
    return Repository.get(`${resource}/status`)
  },
  disconnectSage() {
    return Repository.post(`${resource}/disconnect`)
  },
  getSageAuthUrl(){
    return Repository.get(`${resource}/auth-url`)
  }
};
